<template>
    <div class="page-content">
        <UserHeadline title="Notes.title" description="Notes.description" :empty="!userNotes.length" />
        <EmptyStateNotification :content="$t('Notes.no_notes')" :hint="$t('Notes.no_notes_hint')" v-if="!userNotes.length" />
        <p class="page-content__courses-with-notes" v-html="$t('MemoPageNotesList.courses_with_notes')"></p>
        <div class="page-content__container">
            <MemoPageNotesList
                class="page-content__notes-list"
                :userNotes="userNotes"
                :currentNote="currentNote"
                v-on:selectNote="onSelectNote"
            />
            <MemoPageNotesEditor
                class="page-content__notes-editor"
                :note="currentNote"
                :editable="editable"
                v-on:saveNote="saveNoteAndShowToast"
                v-on:autoSaveNote="saveNote"
                v-on:deleteNote="deleteNote"
                v-on:goToCourse="onGoToCourse"
                ref="noteEditor"
            />
        </div>
    </div>
</template>

<script>
    import MemoPageNotesList from 'components/user/memopage/MemoPageNotesList'
    import MemoPageNotesEditor from 'components/user/memopage/MemoPageNotesEditor'
    import UserHeadline from 'components/user/UserHeadline'
    import EmptyStateNotification from 'components/user/shared/EmptyStateNotification'
    import routeHelper from 'components/shared/mixins/routeHelper'
    import ModalConfirmationDialog from 'components/shared/modals/ModalConfirmationDialog'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [ routeHelper ],
        components: {
            MemoPageNotesList,
            MemoPageNotesEditor,
            UserHeadline,
            EmptyStateNotification,
            ModalConfirmationDialog
        },
        data () {
            return {
                currentNote: null,
                editable: false
            }
        },
        computed: {
            ...mapGetters({
                userNotes: 'Notes/getNotes'
            })
        },
        methods: {
            async onSelectNote (note) {
                this.currentNote = note
                this.editable = true
            },
            async saveNote () {
                const content = this.$refs.noteEditor.getContentOfNote()
                await this.$store.dispatch('Notes/UpsertNote', { courseId: this.currentNote.courseId, content })
            },
            saveNoteAndShowToast () {
                this.saveNote()
                this.$refs.noteEditor.onNoteSaved()
            },
            async deleteNote () {
                this.$modal.show(ModalConfirmationDialog, {
                    text: this.$t('Notes.modal_delete_note'),
                    buttonYesLabel: this.$t('General.yes'),
                    buttonNoLabel: this.$t('General.no'),
                    onYes: this.onDeleteAccepted
                },
                    {
                        name: 'confirmation-dialog',
                        width: '585px',
                        height: 'auto',
                        adaptive: true
                    }
                )
            },
            async onDeleteAccepted () {
                await this.$store.dispatch('Notes/deleteNote', this.currentNote.id)
                this.$modal.hide('dialog')
                this.$refs.noteEditor.onNoteDeleted()
                this.currentNote = null
            },
            onGoToCourse () {
                const slug = `${this.currentNote.courseId}-${this.currentNote.courseSlug}`
                this.goToCourseBySlug(slug)
            }
        },
        created () {
            this.$store.dispatch('Notes/loadNotes')
        }
    }
</script>

<style lang="scss" scoped>
    .page-content {
        &__container {
            display: flex;
            flex-direction: column;

            [class*="desktop"] & {
                flex-direction: row;
            }
        }

        &__notes-list {
            margin: 0 0 20px;

            [class*="desktop"] & {
                margin: 0 20px 0 0;
                flex-basis: 40%;
            }
        }

        &__courses-with-notes {
            margin: 0 0 10px 0;
            font-size: 1.6rem;
            font-family: 'PlusJakartaSans-Bold', sans-serif;
        }

        &__notes-editor {
            [class*="desktop"] & {
                flex-grow: 1;
                flex-basis: 60%;
                display: flex;
                flex-direction: column;
            }
        }

        .icon-info {
            font-size: 2rem;
            margin: 0 0 0 8px;
        }
    }
</style>
